import React from "react";
import {useStore, useSelector} from "react-redux";
import {Redirect} from "react-router-dom";
import {getSubdomain} from "../../../utils/general";


export default function() {

    const userData = useSelector(state => state.user?.decodedTokenData || {})

    // admin
    if (userData.admin) {
        return <Redirect to="/admin/site-dashboard" />
    }
    // subdomain admin on their own subdomain

    if (userData.subdomain_admins.length && userData.subdomain_admins.includes(getSubdomain())) {
        return <Redirect to="/admin/site-dashboard" />
    }

    if (userData.funder_admins) {
        return <Redirect to="/admin/funders" />
    }

    if (userData.program_admins) {
        return <Redirect to="admin/pace-programs" />
    }
    
        return <Redirect to="/" />
    

}